(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .directive('creditsAddon', creditsAddon);

    function creditsAddon() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/addon/credits/credits-addon.html',
            controller: 'CreditsAddonController',
            controllerAs: 'vc'
        };
        return directive;
    }
})();
